import usePollGauge from './usePollGauge'
import { GaugeSvg } from './styled-components'

interface PollGaugeProps {
  average: number | null
  label: string
}

const PollGauge = ({ average, label }: PollGaugeProps) => {
  const { segments, center, tip, needleVisibility, needleColor } = usePollGauge(average)

  return (
    <GaugeSvg viewBox='0 0 200 106' role='img' aria-label={label}>
      {segments.map(segment => (
        <path key={segment.score} d={segment.path} fill={segment.fill} />
      ))}
      <g visibility={needleVisibility}>
        <line
          x1={center.x}
          y1={center.y}
          x2={tip.x}
          y2={tip.y}
          stroke={needleColor}
          strokeWidth={5}
          strokeLinecap='round'
        />
        <circle cx={center.x} cy={center.y} r={7} fill={needleColor} />
      </g>
    </GaugeSvg>
  )
}

export default PollGauge
